import React from 'react';
import { Link } from 'react-router-dom';
import { routes } from "../../../../constants";
import { useStoreActions } from "../../../../contexts";
import { Send1stAgreementIcon } from "../BusinessOnboardingWidget.icons";
import { ActionButton, StepLayout } from "../BusinessOnboardingWidget.utils";
export default function SetupServices() {
  const {
    logBI
  } = useStoreActions();
  return /*#__PURE__*/React.createElement(StepLayout, {
    id: "setupServices",
    title: "Set up services",
    subtitle: "List the services you offer, your pricing, and billing preferences",
    actions: /*#__PURE__*/React.createElement(ActionButton, {
      "data-testid": "onboarding-widget-setup-services",
      as: Link,
      to: routes.serviceLibrary,
      onClick: () => logBI(11214)
    }, "Go to Services"),
    icon: /*#__PURE__*/React.createElement(Send1stAgreementIcon, null)
  });
}